var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.num),function(item){return _c('h4',{key:item.num},[_vm._v(_vm._s(item.name))])}),_vm._l((_vm.obj),function(item,key){return _c('h4',{key:key},[_vm._v(_vm._s(key)+":"+_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }